import React from 'react';

import { Input, Tooltip, Select, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

class FormBuscarPersona extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id_nota: '',
      date: null,
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkNumDoc = (rule, value, callback) => {
    var bool = /^[0-9A-Z]*$/.test(value);
    if (bool) {
      callback();
    } else {
      callback('El numero de documento es unicamente con numeros, sin puntos');
    }
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const prefixDocumento = getFieldDecorator('tipo_doc', {
      initialValue: 'DNI',
    })(
      <Select style={{ width: 70 }}>
        <Option value="DNI">DNI</Option>
        <Option value="CI">CI</Option>
        <Option value="LC">LC</Option>
        <Option value="LE">LE</Option>
        <Option value="PAS">PAS</Option>
        <Option value="RUN">RUN</Option>
      </Select>
    );

    const generoSelector = getFieldDecorator('genero', {
    })(
      <Select placeholder ="Genero" style={{ width: 150 }}>
        <Option value="F">F - Femenino</Option>
        <Option value="M">M - Masculino</Option>
        <Option value="X">X - No Binario</Option>
      </Select>
    );

    return (
      <div>
        <h1 className="tituloForm">Busqueda de Personas</h1>

        <Form onSubmit={this.handleSubmit} className="formularios">
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Documento
                <Tooltip title="Tipo y Numero de documento">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('num_doc', {
              rules: [
                {
                  required: true,
                  message:
                    'Por favor, ingresar el valor de forma correcta, sin puntos ni letras minusculas!',
                  validator: this.checkNumDoc,
                },
              ],
            })(
              <div>
                <Input addonBefore={prefixDocumento} addonAfter={generoSelector} style={{ width: '100%' }} />
              </div>
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Buscar
            </Button>
            <Button type="danger" onClick={this.props.onCancel}>
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormBuscarPersona);
